import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

const STATS = [
  { value: 98.4, decimals: 1, suffix: "%", label: "Visa success rate" },
  { value: 200, decimals: 0, suffix: "+", label: "Students placed", locale: true },
  { value: 10, decimals: 0, suffix: "+", label: "Countries & partner destinations" },
  { value: 50, prefix: "₹", suffix: " CR+", label: "Education loan & scholarship disbursed" },
];

function Counter({ value, decimals = 0, prefix = "", suffix = "", locale = false }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) =>
        setDisplay(locale ? Math.round(v).toLocaleString("en-IN") : v.toFixed(decimals)),
    });
    return () => controls.stop();
  }, [inView, value, decimals, locale]);

  return (
    <span ref={ref}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section data-testid="stats-band" className="hairline-b">
      <div className="container-x grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
            className={`px-6 py-10 lg:py-14 ${i % 2 === 1 ? "border-l border-white/10" : ""} ${
              i >= 2 ? "border-t border-white/10 lg:border-t-0" : ""
            } ${i > 0 ? "lg:border-l lg:border-white/10" : ""}`}
          >
            <p className="font-display text-4xl font-light tracking-tight text-frost sm:text-5xl" data-testid={`stat-value-${i}`}>
              <Counter
                value={s.value}
                decimals={s.decimals}
                prefix={s.prefix || ""}
                suffix={s.suffix}
                locale={s.locale}
              />
            </p>
            <p data-testid={`stat-label-${i}`} className="mt-3 break-words font-mono text-[11px] uppercase tracking-[0.2em] text-mist">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
